import React from 'react';
import styled from 'styled-components';
import czechBasedLogo from '../../assets/czechBasedLogo.png';
import { Section } from '../common';
import Navbar from './Navbar';
import FilterButton from '../../pages/Startups/FilterButton';
import { map } from 'ramda';

const filterButtons = [
  { value: 'web', emoji: 'desktop_computer' },
  { value: 'mobile', emoji: 'iphone' },
  { value: 'startup', emoji: 'rocket' },
  { value: 'hiring', emoji: 'male-technologist' },
];

export default ({ filter, setFilter }) => {
  return (
    <BackgroundColor>
      <HeroHeaderWrapper>
        <Navbar />
        <ContentWrapper>
          <TextWrapper>
            <PrimaryLine>Showroom českých projektu</PrimaryLine>
            <SecondaryLine>Objevujte projekty a startupy z české scény</SecondaryLine>
            <ButtonWrapper>
              <div>Kategorie: </div>
              {map(item => (
                <FilterButton key={item.value} filter={filter} setFilter={setFilter} item={item} />
              ))(filterButtons)}
            </ButtonWrapper>
          </TextWrapper>
          <HeaderImage src={czechBasedLogo} />
        </ContentWrapper>
      </HeroHeaderWrapper>
    </BackgroundColor>
  );
};

const ButtonWrapper = styled.div`
  display: flex;
  font-size: 16px;
  margin: 16px 0;
  color: ${props => props.theme.secondaryTextColor};

  align-items: center;

  & > *:not(:last-child) {
    margin-right: 16px;
  }

  @media screen and (max-width: 600px) {
    display: none;
  }
`;

const HeaderImage = styled.img`
  margin-top: -24px;
  width: 260px;
  height: 260px;
  margin-left: 32px;
  @media screen and (max-width: 1000px) {
    display: none;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TextWrapper = styled.div`
  padding: 96px 0;
`;

const BackgroundColor = styled.div`
  background: white;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
`;

const HeroHeaderWrapper = styled(Section)`
  color: #475059;
`;

const PrimaryLine = styled.div`
  font-weight: bold;
  color: #212529;
  font-size: 48px;
  margin-bottom: 8px;

  @media screen and (max-width: 786px) {
    font-size: 32px;
  }
`;

const SecondaryLine = styled.div`
  font-size: 18px;
  color: #787878;
  font-weight: 400;
  line-height: 32px;
  max-width: 500px;
  margin-bottom: 24px;
`;

// Pravidelně pro vás budeme vytvářet profily zajímavých projektů.
